// src/utils/billing/bulkRowStatus.js
//
// KAN-1028 — one place that says how each bulk-send row status counts and how
// it looks. Row statuses the engine can write:
//   success · already_sent (an earlier attempt of this run's key finished — shown as sent)
//   in_flight (another tab/device is mid-send) · sent_recently (just went out)
//   limited (hourly sending limit — not a failure) · unconfirmed (may have gone out)
//   failure · skipped · working
// Anything else stays "not reached".

export const STATUS_ALREADY_SENT = 'already_sent';
export const STATUS_IN_FLIGHT = 'in_flight';
export const STATUS_SENT_RECENTLY = 'sent_recently';
export const STATUS_LIMITED = 'limited';
export const STATUS_UNCONFIRMED = 'unconfirmed';

export const isSuccessStatus = (s) => s === 'success' || s === STATUS_ALREADY_SENT;
/** Skipped by the server's say-so (not pre-marked by the review). */
export const isBlockedStatus = (s) => s === STATUS_IN_FLIGHT || s === STATUS_SENT_RECENTLY;
export const isSkippedStatus = (s) => s === 'skipped' || isBlockedStatus(s);
/** Reached a final answer this pass (counts toward progress). */
export const isFinishedStatus = (s) => isSuccessStatus(s) || s === 'failure'
  || isBlockedStatus(s) || s === STATUS_UNCONFIRMED;

/** Visual family for a row: collapses the explicit statuses onto the existing palette. */
export function viewStatus(status) {
  if (isSuccessStatus(status)) return 'success';
  if (isBlockedStatus(status)) return 'blocked';
  if (status === STATUS_LIMITED) return 'stopped';
  return status;
}
